function BlogArticle() {
  const blogs = [
  {
    id: 1,
    title: "Reap a natural home",
    desc: "Discover how cities around the world are blending sustainability with modern living. From rooftop gardens to eco-architecture, see how communities are building a greener tomorrow.",
    img: "https://picsum.photos/400/250?random=1",
  },
  {
    id: 2,
    title: "Life in harmony",
    desc: "Explore the art of living in sync with nature. Whether it’s mindful travel, minimal waste living, or connecting with the outdoors, find inspiration to live more sustainably and peacefully.",
    img: "https://picsum.photos/400/250?random=2",
  },
  {
    id: 3,
    title: "A gift of nature",
    desc: "Journey to breathtaking landscapes and hidden natural wonders. Learn how protecting these treasures ensures future generations can enjoy the same beauty that inspires travelers today.",
    img: "https://picsum.photos/400/250?random=3",
  },
  {
    id: 4,
    title: "The beauty of tea",
    desc: "Uncover the timeless charm of tea — from lush green hills to the comforting aroma in every cup. Learn how sustainable tea farming supports local communities while preserving the planet’s natural balance.",
    img: "https://picsum.photos/400/250?random=4",
  },
  {
    id: 5,
    title: "Sustainable living",
    desc: "Discover practical ways to live consciously without compromising comfort. From eco-friendly habits to mindful consumption, explore how small lifestyle changes can create a big impact on the environment.",
    img: "https://picsum.photos/400/250?random=5",
  },
  {
    id: 6,
    title: "Nature’s harmony",
    desc: "Experience the peaceful rhythm of nature and the balance it teaches us. Find inspiration in the wild — where every sound, color, and breeze reminds us of our connection to the Earth.",
    img: "https://picsum.photos/400/250?random=6",
  },
];

  return (
    <section className="py-8 px-2 sm:px-4 md:px-8 lg:px-16 w-full">
      {/* Blog Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
        {blogs.map((blog) => (
          <div
            key={blog.id}
            className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition flex flex-col h-full"
          >
            <img
              src={blog.img}
              alt={blog.title}
              className="w-full h-48 sm:h-56 md:h-64 object-cover"
            />
            <div className="p-4 sm:p-5 flex flex-col flex-1">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800">
                {blog.title}
              </h3>
              <p className="text-gray-500 text-xs sm:text-sm mt-2 flex-1">{blog.desc}</p>
              <button className="mt-4 px-3 sm:px-4 py-2 border border-gray-400 rounded-full text-gray-700 font-medium text-xs sm:text-sm hover:bg-gray-100 transition self-start">
                Learn more →
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default BlogArticle;
